import { z } from 'zod'

export const RecipeRefType = z.enum(['item', 'product'])
export type RecipeRefType = z.infer<typeof RecipeRefType>

export const RecipeItemDto = z.object({
  imId: z.string(),
  qty: z.number(),
})

export const RecipeDto = z.object({
  refType: RecipeRefType,
  refId: z.string(),
  items: z.array(RecipeItemDto),
})

export type RecipeDto = z.infer<typeof RecipeDto>
